<template>
  <fragment>
    <mc-app-header title="_unsafe_ Cloud Functions" />
    <mc-app-body>
      <div class="functions section">
        <div class="mc-container">
          <div
            v-for="(f, index) in functionsData"
            :key="index"
            class="functions__item box"
          >
            <div class="functions__item-desc">
              <div class="functions__item-title">
                {{ f.name }}
              </div>
            </div>
            <b-button
              :disabled="f.disabled"
              :loading="f.loading"
              class="button is-link is-small"
              @click="handleFunctionCall(index)"
            >
              Call
            </b-button>
          </div>
        </div>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import GetParamsModal from './GetParamsModal';

export default {
  data: function() {
    return {
      modalOpen: false
    };
  },
  computed: {
    ...mapState(['functions']),
    functionsData() {
      return this.functions.list
        .filter(f => !f.private)
        .map(f => {
          return {
            ...f,
            disabled:
              this.functions.calling !== '' &&
              f.name !== this.functions.calling,
            loading: this.functions.calling == f.name
          };
        });
    }
  },
  methods: {
    ...mapActions('functions', ['callFunction']),
    getParams(name, paramsList) {
      return new Promise((resolve, reject) => {
        this.$buefy.modal.open({
          parent: this,
          component: GetParamsModal,
          hasModalCard: true,
          props: {
            name,
            paramsList
          },
          events: {
            input: resolve
          },
          onCancel: reject
        });
      });
    },
    async handleFunctionCall(index) {
      const f = this.functions.list[index];
      const params = await this.getParams(f.name, f.params);
      try {
        await this.callFunction({
          name: f.name,
          params: params
        });
        this.$buefy.toast.open({
          // We cannot depend on result status as we are using no-cors mode for request.
          // We have to impliment CORS on the server to use cors mode, but as these
          // functions will rarely be called and will succeed in most of the cases.
          // the fix doesn't seem to be worth the developer time.
          message:
            'Fuction call triggered! please check firebase logs for actuall status.',
          type: 'is-success'
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: e.message || 'Error Calling Function!',
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.functions {
  height: 100%;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__item-desc {
    flex: 1 0 0;
  }

  &__item-title {
    margin-bottom: 0.5rem;
  }

  .button:not(:last-child) {
    margin-right: 0.5rem;
  }
}
</style>
